<template>
<main class="notice">
  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ $t('notice.title') }}</h1>

  <!-- Container -->
  <section class="container">
    <div class="flex-center" v-show="isLoading">
      <div class="row">
      <template v-if="noticeList && noticeList.length">
        <ul class="notice-list">
          <li class="box" v-for="(news, news_idx) in noticeList" :key="news_idx" @click="showNotice(news)">
            <div class="title">{{ $t(`news[${news.news_id}].title`) }}</div>
            <div class="date">{{ news.open_date }}</div>
          </li>
        </ul>
      </template>
      <template v-else>
        <div class="box" v-show="!isLoading">{{ $t('notice.no-message') }}</div>
      </template>
      </div>
    </div>
  </section>
</main>
</template>

<script>
  import {api} from "../../config";
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    data () {
      return {
        loading: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      isLoading () {
        return this.loading
      },
      noticeList() {
         return this.$store.getters.newslist
      },
    },
    
    created() {
      this.loading = false
    },

    mounted() {
      
      const self = this
      self.$store.dispatch('showLoading', true)
      
      if(!this.$store.getters.newslist || this.$store.getters.newslist.length == 0) {
        this.$store.dispatch('getNewsList')
          .then(() => {
            self.loading = true
            self.$store.dispatch('showLoading', false)
          })
      } else {
        self.loading = true
        self.$store.dispatch('showLoading', false)
      }
    },
    methods: {
      showNotice(data) {
        this.$router.push({name: 'notice.detail', params: { news_id: data.news_id }})
      },
      back() {
        this.$router.push({name: 'top'})
      }
    },

  }
</script>
